import {useState} from "react"
import {createContainer} from "unstated-next"
import {ConversationStatus} from "./graphql"

export const TopicSearchContainer = createContainer(() => useState(""))
export const ConversationSearchContainer = createContainer(() => useState(""))
export const ConversationStatusContainer = createContainer(() =>
    useState<readonly ConversationStatus[]>([]),
)
